import { getApiActionTypes } from '../redux_utils';

export const ACTIONS = {
  ...getApiActionTypes('FETCH_INITIAL_PRICE'),
  ...getApiActionTypes('UPDATE_INITIAL_PRICE_FEEDBACK'),
};
